const applyBrowserHacks = () => {
    disableTextSelection()
}

const disableTextSelection = () => {
    // don't allow text selection in IE
    document.onselectstart = function() {
        return false
    }
}

export default applyBrowserHacks
